import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Section } from '../../common/Section';
import { messages } from '../../../../i18n';
import { TransformationsList } from './TransformationLists';
import { TransformationsCustomSetup } from './TransformationsCustomSetup';

export const Transformations: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Section title={formatMessage(messages['demo.section.transformation'])}>
      <TransformationsList />
      <TransformationsCustomSetup />
    </Section>
  );
};
